import { FeatureFlag } from '@/features/standortContext/entities/featureFlag';
import { Standort } from '@/features/standortContext/entities/standort';
import { GET_STANDORTE_FOR_MANAGER } from '@/features/standortContext/hooks/graphql/queries';
import {
  GetStandorteForManagerQuery,
  Manager,
  ManagerError,
} from '@/gql/graphql';
import { handleGraphQLErrors } from '@/utils/errors/handleGraphQLErrors';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useStandorte(): {
  standorte: Standort[];
  hauptStandort?: Standort;
  error?: string;
} {
  const { data } = useSuspenseQuery<GetStandorteForManagerQuery>(
    GET_STANDORTE_FOR_MANAGER,
  );

  const error = handleGraphQLErrors<Pick<Manager, '__typename'>, ManagerError>(
    data.manager,
  );

  if (error) {
    Sentry.captureException(error);
    return { standorte: [] };
  }

  const standorte: Standort[] = [];
  let hauptStandort: Standort;
  if (data.manager.__typename === 'Manager') {
    const managerResult = data.manager as Manager;
    // oxlint-disable-next-line complexity
    managerResult.standorte.forEach((standort) => {
      const mappedStandort = new Standort({
        id: standort.id,
        uid: standort.uid,
        idStandortgruppe: standort.idStandortgruppe,
        name: standort.name,
        storeNummer: standort.storeNummer ?? undefined,
        abteilungenEnabled: standort.settings?.abteilungenEnabled ?? false,
        isTerminVerknuepfung: standort.settings?.isTerminVerknuepfung ?? false,
        featureFlags: standort.featureFlags.map(
          (flag) =>
            new FeatureFlag({ name: flag.name, isActive: flag.isActive }),
        ),
        land: standort.land,
        isAuditAktiv: standort.isAuditAktiv,
        qualifikationenEnabled: standort.settings?.qualifikationenEnabled,
        isGuttagekontenAktiviert: standort.isGuttagekontenAktiviert,
      });
      standorte.push(mappedStandort);

      if (managerResult.idStandort === standort.id) {
        hauptStandort = mappedStandort;
      }
    });
  }

  return { standorte, hauptStandort };
}
